import React, { useState, useEffect } from 'react';
import css from './css.less';
import Table from '@/src/components/Antd/Table/SizeFittingTable';
import {
  EditOutlined,
  CloseOutlined,
  RightOutlined,
  DownOutlined,
} from '@ant-design/icons';
import AddNew from 'src/components/GreenAddBtn/GreenAddBtn';
const CustomTable = (props) => {
  const {
    data,
    columns,
    onRowClick,
    id,
    addText,
    addFun,
    rowDeleteFunc,
    className,
    disableAdd,
    collapsible,
    collapsibleText,
    ...rest
  } = props;
  const [collapse, setCollapse] = useState(true);
  const [collapseTitle, setCollapseTitle] = useState(
    columns.length ? columns[columns.length - 1].title : '',
  );

  useEffect(() => {
    setCollapseTitle(collapseTitle);
  }, []);

  const deleteCol = React.useMemo(() => {
    if (rowDeleteFunc) {
      return [
        ...columns,
        {
          title: '',
          default: true,
          key: 'action',
          render: (text, record, index) => (
            <div
              className={css.deleteContainer}
              onClick={() => {
                rowDeleteFunc(index, record);
              }}>
              <CloseOutlined />
            </div>
          ),
          width: 64,
        },
      ];
    } else if (collapsible) {
      const collapsibleColumns = columns;
      const child = collapse ? <DownOutlined /> : <RightOutlined />;
      collapsibleColumns[collapsibleColumns.length - 1].title = (
        <div className={css.tableFolding}>
          {collapseTitle}
          <div
            className={css.tableFoldIcon}
            onClick={() => setCollapse(!collapse)}>
            {child}
          </div>
        </div>
      );
      return collapsibleColumns;
    } else {
      return columns;
    }
  }, [columns, rowDeleteFunc, collapse]);

  const dataCollapse = !collapse ? [] : data;

  return (
    <React.Fragment>
      <div
        className={!collapse ? css.collapseContainer : css.container}
        onClick={(e) => {
          console.log('TableClick');
        }}>
        <Table
          id={id}
          className={className}
          dataSource={dataCollapse}
          columns={deleteCol}
          onRow={(record, index) => {
            return {
              onClick: (event) => {
                if (onRowClick) onRowClick(index);
              }, // 点击行
            };
          }}
          pagination={false}
          {...rest}
        />
        {/* 折叠 */}
        {!collapse && (
          <div className={css.collapseIntroduce}>
            {collapsibleText}{' '}
            <span className={css.unfold} onClick={() => setCollapse(!collapse)}>
              unfold
            </span>{' '}
            to view more
          </div>
        )}
      </div>
      {addFun && (
        <AddNew
          className={css.addNew}
          addFun={addFun}
          addText={addText}
          disable={disableAdd}
        />
      )}
    </React.Fragment>
  );
};
export default CustomTable;
const EditIcon = (props) => {
  return <EditOutlined className={css.icon} />;
};
const BackTitle = (props) => {
  const { children } = props;
  return <div className={css.backHeader}>{children}</div>;
};
const FrontTitle = (props) => {
  const { children } = props;
  return <div className={css.frontHeader}>{children}</div>;
};
const MidTitle = (props) => {
  const { children } = props;
  return <div className={css.midHeader}>{children}</div>;
};
const FirstTitle = (props) => {
  const { children } = props;
  return <div className={css.firstHeader}>{children}</div>;
};

export { EditIcon, BackTitle, FrontTitle, FirstTitle, MidTitle };
